import { Box, VStack, HStack, Text, Menu, MenuButton, MenuList, MenuItem, IconButton } from "@chakra-ui/react";
import { Pencil, MoreVertical, Trash2 } from "../../../shared/icons";
import { EVENT_KIND_META, eventLabel, eventPeriod } from "../../calendarEvents/utils/calendarEventKinds";

// Um compromisso (folga, férias...) com ícone do tipo, período, observação e o menu
// editar/excluir — o mesmo no popover do dia, na Semana e na Lista. Cor neutra: compromisso
// não é valor nem status financeiro.
export default function CalendarEventRow({ event, onEdit, onDelete }) {
  const Icon = EVENT_KIND_META[event.tipo]?.icon;
  return (
    <HStack justify="space-between" align="flex-start" data-testid="calendar-event-row">
      <HStack align="flex-start" spacing={2} minW={0}>
        <Box color="app-muted-fg" pt={0.5} display="inline-flex">
          {Icon ? <Icon size={14} aria-hidden /> : null}
        </Box>
        <VStack align="flex-start" spacing={0.5} minW={0}>
          <Text fontSize="sm" fontWeight="medium">
            {eventLabel(event)}
          </Text>
          <Text fontSize="xs" color="app-muted-fg">
            {event.titulo ? `${EVENT_KIND_META[event.tipo]?.label} · ` : ""}
            {eventPeriod(event)}
            {event.horas ? ` · ${event.horas}h` : ""}
          </Text>
          {event.observacao ? (
            <Text fontSize="xs" color="app-muted-fg" noOfLines={2} title={event.observacao}>
              {event.observacao}
            </Text>
          ) : null}
        </VStack>
      </HStack>
      {onEdit || onDelete ? (
        <Menu placement="bottom-end" isLazy>
          <MenuButton as={IconButton} aria-label={`Ações do compromisso ${eventLabel(event)} ${eventPeriod(event)}`} icon={<MoreVertical size={14} />} size="xs" variant="ghost" flexShrink={0} />
          <MenuList>
            {onEdit ? (
              <MenuItem icon={<Pencil size={14} />} onClick={() => onEdit(event)}>
                Editar
              </MenuItem>
            ) : null}
            {onDelete ? (
              <MenuItem icon={<Trash2 size={14} />} color="danger-text" onClick={() => onDelete(event)}>
                Excluir
              </MenuItem>
            ) : null}
          </MenuList>
        </Menu>
      ) : null}
    </HStack>
  );
}
